/* eslint-disable */
import React, {Component} from 'react'
import jMoment from 'moment-jalaali'
import InputMask from 'react-input-mask'
import moment from 'moment'

class SingleDatePicker extends Component {
  constructor(props) {
    super(props)
  }

  epochFrom = (x) => {
    if (
      x.match(
        /^[1-4]\d{3}\/((0[1-6]\/((3[0-1])|([1-2][0-9])|(0[1-9])))|((1[0-2]|(0[7-9]))\/(30|([1-2][0-9])|(0[1-9]))))$/
      )
    ) {
      var concatDayMount = x.split('/')
      var concatDate = concatDayMount[1] + concatDayMount[2]
      var constantDate = '0631'
      var n = concatDate.localeCompare(constantDate)

      let miladiDate = jMoment(x, 'jYYYY/jM/jD').format('YYYY/M/D')
      let from = miladiDate + ' ' + '00:00'
      let fromEpoch = moment.utc(from).valueOf()
      if (n >= 0) {
        return fromEpoch - 3.5 * 3600 * 1000
      } else {
        return fromEpoch - 3.5 * 3600 * 1000
      }
    }
  }
  epochTo = (x) => {
    if (
      x.match(
        /^[1-4]\d{3}\/((0[1-6]\/((3[0-1])|([1-2][0-9])|(0[1-9])))|((1[0-2]|(0[7-9]))\/(30|([1-2][0-9])|(0[1-9]))))$/
      )
    ) {
      var concatDayMount = x.split('/')
      var concatDate = concatDayMount[1] + concatDayMount[2]
      var constantDate = '0631'
      var n = concatDate.localeCompare(constantDate)

      let miladiDate = jMoment(x, 'jYYYY/jM/jD').format('YYYY/M/D')
      let to = miladiDate + ' ' + '23:59:59'
      let toEpoch = moment.utc(to).valueOf()
      if (n >= 0) {
        return toEpoch - 3.5 * 3600 * 1000
      } else {
        return toEpoch - 3.5 * 3600 * 1000
      }
    }
  }

  onChangeDate = (event) => {
    let dateValue = event.target.value

    // this.props.onChangeDate('a')
    if (
      event.target.value.match(
        /^[1-4]\d{3}\/((0[1-6]\/((3[0-1])|([1-2][0-9])|(0[1-9])))|((1[0-2]|(0[7-9]))\/(30|([1-2][0-9])|(0[1-9]))))$/
      )
    ) {
      this.props.setDate({
        from: this.epochFrom(dateValue),
        to: this.epochTo(dateValue)
      })
    } else {
      this.props.setDate({
        from: 0,
        to: 0
      })
    }
  }

  render() {
    return (
      <div className="formComponent relativeComponent">
        <label className="labelComponent">{this.props.dateLabel} </label>
        <InputMask
          c
          autocomplete="off"
          placeholder="yyyy/mm/dd"
          className="form-control"
          mask="9999/99/99"
          maskChar={null}
          onChange={this.onChangeDate}
        />
      </div>
    )
  }
}

export default SingleDatePicker
